// extracted by mini-css-extract-plugin
export default {"pending-tag":"CertificateTaskStatus_pending-tag__4O3Rc","complete-tag":"CertificateTaskStatus_complete-tag__F+J-6"};